import { z } from 'zod';
import { ConversationParticipant } from '../client';
import { makeEvent } from './EventBase';

export const ConversationParticipantUpdated = makeEvent(
    'Conversation\\ConversationParticipantUpdated',
    z.object({
        data: ConversationParticipant,
    }),
);

export type ConversationParticipantUpdated = (typeof ConversationParticipantUpdated)['schema']['_output'];
